module.exports = __webpack_public_path__ + "img/moon.a3ba676f.svg";